/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:-ms-flexbox;display:flex;-ms-flex:1 1 auto;flex:1 1 auto}.loader[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100vw;height:100vh;overflow:hidden;background:#fff;z-index:9999}"];
export { styles as styles };
